import ITask from './ITask';
import Game from '../../Game';
import { GameActions } from '../../State/Game/GameActions';
import { ContextType } from '../../State/Game/ContextType';
import { IMessagePayload } from '../../State/Game/IEntryPointData';

export default class SendCoinsTask implements ITask<any> {
    private taskData: {
        payload?: IMessagePayload;
        [key: string]: any;
    };

    constructor(params: { payload?: IMessagePayload; [key: string]: any }) {
        this.taskData = params;
    }

    public *execute(): IterableIterator<any> {
        GameActions.setContext(ContextType.GIVE_CURRENCY, this.taskData);
    }
}
